import React from 'react'
import './Footer.css';

function Footer() { 
    return (
        <>
        <div className="footer_container">
            <p>© 2025 Accenture. All Rights Reserved. Accenture Confidential. For internal use only. Powered by the Learning Experiences - L&TT, ATCI.</p>
        </div>
        </>
    )
}
//copyrights updated to 2025
export default Footer
